/** Enumerates the CRM entity kinds (accounts, contacts, deals, activities, routes, etc.), each valued as the API's path segment for that entity. */
enum EntityType {
  ACTIVITY = "crm-activities",
  COMPANY = "accounts",
  COMPANY_GROUP = "account-groups",
  COMPANY_ROUTE = "account-routes",
  DEAL = "deals",
  DEAL_GROUP = "deal-groups",
  /** Per user-day location distance. Not a CRM record: a metric row, like LEADERBOARD. */
  DISTANCE = "distance",
  FOLDER = "folders",
  HISTORY = "history",
  INTEGRATION = "integration",
  LEAD = "leads",
  LEADERBOARD = "leaderboard",
  PEOPLE_GROUP = "contact-groups",
  PEOPLE_ROUTE = "contact-routes",
  PERSON = "contacts",
  PIN = "pins",
  RESOURCE = "resources",
  ROUTE = "unified-routes",
  SAVED_FILTERS = "savedFilters",
  TERRITORY = "territories",
  TRIP = "trips",
  USER = "users",
}

export default EntityType;
